import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import { string } from 'prop-types';
import {
  params, shape, arrayOf, string as stringType, useDataModel
} from '@thd-nucleus/data-sources';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { Heading } from '@thd-olt-component-react/heading';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import styles from './store-directory.module.scss';

const cx = classNames.bind(styles);

const StateServicesComponent = ({ state }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('state-services.ready'); }, []);

  const { data, loading, error } = useDataModel('storeDirectoryByState', {
    variables: { state }
  });

  const servicesInfo = data?.storeDirectoryByState?.servicesInfo || [];
  const stateName = data?.storeDirectoryByState?.stateName || '';

  if (loading) {
    return (
      <article className={cx('store-directory')}>
        <Heading />
        <LoadingPlaceholder
          color="#E0E0E0"
          ready={false}
          showLoadingAnimation
          style={{ height: 700 }}
          rows={20}
          type="text"
        ><div />
        </LoadingPlaceholder>
      </article>
    );
  }
  if (!servicesInfo?.length || error) return null;

  return (
    <article className={cx('store-directory')}>
      <section className={cx('store-directory__header')}>
        <Heading title={`${stateName} Services`} underline />
      </section>
      <section className={cx('store-directory__state-wrapper')}>
        {servicesInfo.map(({ city: cityName, cityServiceLink }, cityIndex) => {
          return (
            <div className={cx('store-directory__city-services')} key={`${cityName}-${cityIndex}`}>
              <a
                className={styles['store-directory__city-link']}
                id={`${cityName}-${cityIndex}`}
                href={cityServiceLink}
              >
                {`${cityName} Services`}
              </a>
            </div>
          );
        })}
      </section>
    </article>
  );
};

const propTypes = {
  state: string.isRequired
};

StateServicesComponent.displayName = 'StateServices';

const dataModel = {
  storeDirectoryByState: params({ state: stringType().isRequired() }).shape({
    stateName: stringType(),
    servicesInfo: arrayOf(shape({
      city: stringType(),
      cityServiceLink: stringType(),
    }))
  })
};

StateServicesComponent.dataModel = dataModel;
StateServicesComponent.propTypes = propTypes;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'state-directory',
  placeholder: (
    <LoadingPlaceholder
      color="#f5f5f5"
      ready={false}
      style={{ height: 750 }}
      type="rect"
    ><div />
    </LoadingPlaceholder>
  ),
  scrollBuffer: 100,
}, StateServicesComponent);

const StateServices = withDynamicComponent(HydratedComponent);

StateServices.dataModel = dataModel;
StateServices.propTypes = propTypes;

export { StateServices };